import { call, put } from "redux-saga/effects";
import { refreshAccessTokenSaga } from "../auth/refreshAccessToken/refreshAccessToken";
import { postLoginAction } from "../postLogin/action";
import { setDefaultBackground } from "../../state/background/backgroundSlice";
import { getDefaultBackground } from "../../browser/storage";

export function* initializeAppSaga() {
  try {
    const savedBackground = yield call(getDefaultBackground);
    yield put(setDefaultBackground(savedBackground));
    const ok = yield call(refreshAccessTokenSaga);
    if (!ok) {
      console.warn("Refresh token failed, skipping postLogin");
      return;
    }
    yield put(postLoginAction());
  } catch (error) {
    console.error("Failed to initialize app:", error);
  }
}
